export enum Type {
    FormBuilder = 'formbuilder',
    ContentBox = 'contentbox',
    Attachment = 'attachment',
    PageBreak = 'pagebreak',
    TextField = 'textfield',
    Datepicker = 'datepicker',
    Droplist = 'droplist',
    Checkbox = 'checkbox',
    CheckList = 'checklist',
    Signature = 'signature',
    Pdf = 'pdf',
    InternalLinking = 'internallinking'
}